import React, { useState } from "react";
import {
  Heart,
  Info,
  Maximize2,
  RotateCw,
  Trash2,
  ZoomIn,
  ZoomOut,
} from "lucide-react";
import { PROFILE } from "../data";
import { getNode } from "../fs";
import "./utility.css";

export default function PhotosApp({ payload }) {
  const file = payload?.fileId ? getNode(payload.fileId) : null;
  const src = payload?.src || file?.open?.src || PROFILE.avatar;
  const name = file?.name || payload?.name || "Profile.png";
  const [zoom, setZoom] = useState(1);
  const [angle, setAngle] = useState(0);

  return (
    <div className="ph">
      <div className="ph-stage">
        <img
          src={src}
          alt={name}
          style={{ transform: `scale(${zoom}) rotate(${angle}deg)` }}
        />
      </div>

      <div className="ph-bar">
        <button className="xp-icon-btn" onClick={() => setZoom((z) => Math.max(0.2, z - 0.2))} aria-label="Zoom out">
          <ZoomOut size={17} />
        </button>
        <span className="ph-zoom">{Math.round(zoom * 100)}%</span>
        <button className="xp-icon-btn" onClick={() => setZoom((z) => Math.min(5, z + 0.2))} aria-label="Zoom in">
          <ZoomIn size={17} />
        </button>
        <button className="xp-icon-btn" onClick={() => setZoom(1)} aria-label="Fit to window">
          <Maximize2 size={16} />
        </button>
        <button className="xp-icon-btn" onClick={() => setAngle((a) => a + 90)} aria-label="Rotate">
          <RotateCw size={16} />
        </button>
        <span className="ph-bar__sep" />
        <button className="xp-icon-btn" aria-label="Favourite">
          <Heart size={16} />
        </button>
        <button className="xp-icon-btn" aria-label="Info">
          <Info size={16} />
        </button>
        <button className="xp-icon-btn" aria-label="Delete">
          <Trash2 size={16} />
        </button>
      </div>

      <div className="ph-caption">{name}</div>
    </div>
  );
}
